/* eslint-disable jira/filename-case */
import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from './createJpdExperience.tsx';
import type {
	ExperienceErrorReason,
	ExperienceMetadataExtra,
	JPDExperience,
} from './ExperienceMetadataExtra.types.tsx';

export const dialogLoad: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.shared.control-dialog-load', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	}),
);

export const loadStakeholders: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.shared.load-stakeholders', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const addStakeholders: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.shared.add-stakeholders', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const removeStakeholders: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.shared.remove-stakeholders', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const loadSettings: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.shared.load-settings', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const updateSettings: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.shared.update-settings', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const loadSiteConfig: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.shared.load-site-config', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const loadSitePublicSharingConfig: JPDExperience<
	ExperienceErrorReason,
	ExperienceMetadataExtra
> = createJpdExperience(
	new UFOExperience('jpd.shared.load-site-public-sharing-config', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);
